import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { LectionarySource } from '../../services/lectionary-source.service';
import { LectionarySourceEditComponent } from '../lectionary-source-edit/lectionary-source-edit.component';

@Component({
  selector: 'app-lectionary-source',
  templateUrl: './lectionary-source.component.html',
  styleUrls: ['./lectionary-source.component.css']
})
export class LectionarySourceComponent implements OnInit {


  public isLoading = false;

  public entities: LectionarySource[];

    constructor(
      public dialog: MatDialog,
      private apiSvc: ApiService
    ) { }

    ngOnInit() {
      this.loadEntities();
    }

    private loadEntities() {
      this.isLoading = true;
      this.apiSvc.get("api/LectionarySource/name", null).subscribe(
        (data: LectionarySource[]) => {
          this.entities = data;
          this.isLoading = false;
          console.log(this.entities);
        },
        (err) => {
          this.isLoading = false;
          console.log("error", err);
        }
      );
  }

  public add() {
    var modal = this.dialog.open(LectionarySourceEditComponent); 
    modal.componentInstance.LoadItem(null);

    modal.afterClosed().subscribe((savedItem: any) => {
      console.log("modal closed", savedItem);
      if (savedItem !== undefined) {
        this.loadEntities();
      }
    });
  }

  public edit(obj: LectionarySource) {

    var modal = this.dialog.open(LectionarySourceEditComponent);
    modal.componentInstance.LoadItem(obj.Id);

    modal.afterClosed().subscribe((savedItem: LectionarySource) => {

      console.log("modal closed", savedItem);

      if (savedItem !== undefined) {
        obj.Name = savedItem.Name;
        obj.Description = savedItem.Description;
        obj.IsActive = savedItem.IsActive;
      }

    });

  }


}

